import ChangePaymentSelectMethod from "./ChangePaymentSelectMethod";
import {
    CashierContentLeftStyled,
    CashierContentRightStyled,
    CashierContentSelectCountryStyled
} from "../../../Cashier/styled/CashierStyled";
import { ChangePaymentMethodRowStyled } from "./styled/ChangePaymentStyled";
import { Button, Form, FormGroup } from "react-bootstrap";
import { createStructuredSelector } from "reselect";
import { getAppUser, getAvailableCountries } from "../../../../app/appSelectors";
import { makeSelectPayoutError } from "../../accountSelectors";
import { logAction, userUpdateAction } from "../../../../app/appActions";
import { resetAccountErrorAction } from "../../accountActions";
import { connect } from "react-redux";
import _ from "lodash";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useCallback, useEffect, useState } from "react";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import PaymentMethodLogo from "../PaymentMethodLogo/PaymentMethodLogo";
import { usePaymentOpenModuleUrl } from "../paymentHooks";
import { SelectCountry } from "../../../../components/SelectCountry/SelectCountry";

function ChangePayment(props) {
    const {getLangPath} = useLangContext();
    const {
        logAction,
        availableCountries,
        children,
        initialPaymentId,
        isSelectMethodSlider,
        user,
        type,
        extAvailableMethods, // depositAvailableMethods
        extGetAvailableMethods, // depositGetAvailableMethods
        rightColumnComponent,
        selectedPayment,
        setSelectedPayment,
        userUpdate,
        resetAccountError,
    } = props;

    const [selectedCountry, setSelectedCountry] = useState(null);
    const {
        isOpened: isChangePaymentMethodOpened,
        setOpened: setOpenedChangePaymentMethod,
    } = usePaymentOpenModuleUrl('change-payment-method');
    const [availableMethods, setAvailableMethods] = useState([]);
    const {handleGTMClick} = useGTMEvent({module: 'Cashier'})

    const getLastPaymentId = useCallback(() => {
        if (user) {
            if (type === 'deposit') {
                return user.provider_deposit;
            } else {
                return user.provider_payout;
            }
        }
    }, [type, user]);

    const getDefaultPaymentMethod = useCallback(() => {
        return _.sortBy(availableMethods, 'pos')[0];
    }, [availableMethods]);

    const updateLastPaymentId = useCallback((id) => {
        if (getLastPaymentId() !== id) {
            if (type === 'deposit') {
                userUpdate({
                    provider_deposit: id
                });
            } else {
                userUpdate({
                    provider_payout: id
                });
            }
        }
    }, [getLastPaymentId, type, userUpdate]);

    /**
     * Эффект обновления списка методов
     */
    useEffect(() => {
        // console.log('cl Эффект обновления списка методов');
        // console.log('cl setAvailableMethods', extAvailableMethods);
        setAvailableMethods(extAvailableMethods);
    }, [extAvailableMethods]);

    /**
     * Обработчик выбора страны
     */
    const setSelectedCountryHandler = useCallback((iso) => {
        // console.log('cl Обработчик выбора страны', iso);
        const country = _.find(availableCountries, {iso});
        if (country && country.iso !== selectedCountry?.iso) {
            logAction({
                modal: 'cashier',
                tab: type,
                operation: 'country',
                country: country.iso,
            });
            // console.log('cl userUpdate', country.iso);
            userUpdate({
                country: country.iso,
            });
            // console.log('cl setSelectedCountry', country);
            setSelectedCountry(country);
            // console.log('cl setAvailableMethods', []);
            setAvailableMethods([]);
            // console.log('cl setSelectedPayment', null);
            setSelectedPayment(null);
        }
        handleGTMClick({
            button: 'selected country',
            country_iso: country.iso,
        })
    }, [availableCountries, selectedCountry, handleGTMClick, logAction, type, userUpdate, setSelectedPayment]);

    /**
     * Эффект после получения списка стран и выбор страны пользователя
     */
    useEffect(() => {
        if (availableCountries.length && !selectedCountry) {
            const country = _.find(availableCountries, {iso: user.country});
            if (!country) {
                setSelectedCountryHandler('br');
            } else {
                setSelectedCountry(country);
            }
        }
    }, [availableCountries, setSelectedCountryHandler, user, selectedCountry]);

    /**
     * Эффект после выбора страны: запросить список платежных методов
     */
    useEffect(() => {
        // console.log('cl Эффект после выбора страны: запросить список платежных методов');
        if (selectedCountry) {
            // console.log('cl extGetAvailableMethods', selectedCountry.iso);
            extGetAvailableMethods({
                country: selectedCountry.iso
            });
        }
    }, [selectedCountry, extGetAvailableMethods]);

    /**
     * Обработчик выбора платежного метода
     */
    const setSelectedPaymentHandler = useCallback((payment) => {
        logAction({
            modal: 'cashier',
            tab: type,
            operation: 'payment',
            payment_id: payment.id,
            payment_name: payment.label,
        });
        setSelectedPayment(payment);
        setOpenedChangePaymentMethod(false);
        updateLastPaymentId(payment.id);
        handleGTMClick({
            button: 'provider',
            tab: type,
            provider: payment.label,
        })
    }, [logAction, type, setSelectedPayment, setOpenedChangePaymentMethod, updateLastPaymentId, handleGTMClick]);

    const handleChangeMethodClick = useCallback(() => {
        setOpenedChangePaymentMethod(true);
        handleGTMClick({button: 'change method'});
        resetAccountError();
    }, [handleGTMClick, resetAccountError, setOpenedChangePaymentMethod]);

    /**
     * Эффект после получения списка методов, автовыбор метода, если он только один или был уже выбран
     */
    useEffect(() => {
        const isNeedToSelectPayment = !selectedPayment || !_.find(availableMethods, {id: selectedPayment?.id});
        if (isNeedToSelectPayment && availableMethods.length === 1) {
            setSelectedPayment(availableMethods[0]);
        } else if (isNeedToSelectPayment) {
            const initialMethod = _.find(availableMethods, {id: initialPaymentId})
            const userMethod = _.find(availableMethods, {id: getLastPaymentId()});
            const defaultPaymentMethod = getDefaultPaymentMethod();
            if (initialMethod) {
                setSelectedPayment(initialMethod);
            } else if (userMethod) {
                setSelectedPayment(userMethod);
            } else if (defaultPaymentMethod) {
                setSelectedPayment(defaultPaymentMethod);
                updateLastPaymentId(defaultPaymentMethod.id);
            }
        }
    }, [availableMethods, selectedPayment, setSelectedPayment, getLastPaymentId, getDefaultPaymentMethod, updateLastPaymentId, initialPaymentId]);

    return <>

        {
            <ChangePaymentSelectMethod
                show={isChangePaymentMethodOpened}
                availableMethods={availableMethods}
                isSliderWrapper={isSelectMethodSlider}
                selectedCountry={selectedCountry}
                selectedPayment={selectedPayment}
                setSelectedCountryHandler={setSelectedCountryHandler}
                setSelectedPaymentHandler={setSelectedPaymentHandler}
                setOpenedChangePaymentMethod={setOpenedChangePaymentMethod}
            />
        }

        {
            (selectedCountry && selectedPayment && !isChangePaymentMethodOpened) && <>
                <CashierContentLeftStyled>
                    {children}
                </CashierContentLeftStyled>
                <CashierContentRightStyled>
                    <Form.Label>{getLangPath('deposit.payment_method')}</Form.Label>
                    <CashierContentSelectCountryStyled>
                        <ChangePaymentMethodRowStyled>
                            <div className={'d-flex align-items-center gap-3'}>
                                <PaymentMethodLogo paymentKey={selectedPayment.key}/>
                                <span className={'f16'}>{selectedPayment.label}</span>
                            </div>
                            <Button variant={'info'} onClick={handleChangeMethodClick} size={'lg'}>
                                {getLangPath('payment.change')}
                            </Button>
                        </ChangePaymentMethodRowStyled>
                    </CashierContentSelectCountryStyled>

                    {!!rightColumnComponent && rightColumnComponent}
                </CashierContentRightStyled>
            </>
        }
        {
            (selectedCountry && !selectedPayment && !isChangePaymentMethodOpened) && <FormGroup className="p-3">
                <Form.Label>
                    {getLangPath('payment.country')}
                </Form.Label>
                <SelectCountry
                    availableCountries={availableCountries}
                    onSelect={setSelectedCountryHandler}
                    selectedCountry={selectedCountry}
                />
            </FormGroup>
        }
    </>
}

const mapStateToProps = createStructuredSelector({
    availableCountries: getAvailableCountries,
    payoutError: makeSelectPayoutError(),
    user: getAppUser,
});

const mapDispatchToProps = (dispatch) => ({
    logAction: (payload) => dispatch(logAction(payload)),
    resetAccountError: (payload) => dispatch(resetAccountErrorAction(payload)),
    userUpdate: (payload) => dispatch(userUpdateAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePayment);
